import { EntityController } from "./EntityController";
import { TulipAssetConstant } from "../TulipAssetConstants";
import { COCOS_PLAN_MODULE_PATH } from "../../constants";
import { GUIConstants } from "../../cocos/scripts/utils/GUIConstants";
import { PlanManager } from "../../cocosPlan";
import { Canopy, Commands, ComponentConstants, Joinery, JoineryType, SceneConstants } from "@rhinov/savane-js";
import { ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, getFrontUrl, getMediaUrl } from "@rhinov/asset-manager-service";



export class JoineryEntityController extends EntityController {

    allModelsForCurrentJoinery: any; 
    declare entity: Joinery; 

    constructor(entity: Joinery, panel: any, deliverable: any, openAssetDetailCallback: CallableFunction) {
        super(entity, panel, deliverable, openAssetDetailCallback);
        this.allModelsForCurrentJoinery = TulipAssetConstant.getinstance().getModelList(this.entity);
        this.updatepreviewJoinery();
        
    }

    updateProperties(key: string) {  
        this.updateJoineryProperties();
        super.updateProperties(key);
    }

    isJoineryModelSelected(modele: any): boolean {
        var obj = this.entity;
        var component = obj.getComponent(ComponentConstants.ComponentType.JoineryType) as JoineryType;

        if (component && component.joineryTypeId === modele._id) {
            return (true);
        }
        return (false);
    };

    updateJoineryModeleType(modele: any) {
        var obj = this.entity;
        obj.scalable = modele.isScalable;
        if (modele.isScalable === false) {
            obj.length = modele.dimensions.length;
            obj.height = modele.dimensions.height;
            if (obj.joineryType === SceneConstants.JoineryType.canopy) {
                if (obj.height < 1500) {
                    obj.floorHeight = 1000;
                }
                else {
                    obj.floorHeight = 0;
                }
            }
        }
        if (modele.joineryColor !== undefined && modele.joineryColor !== null) {
            obj.freeColor = false;
            obj.materialType = modele.joineryColor;
            this.model.materialType = "" + modele.joineryColor;

        }
        else {
            obj.freeColor = true;
        }
        if (modele.canopyNbPanel !== undefined && modele.canopyNbPanel !== null) {
            (obj as Canopy).nbCasement = modele.canopyNbPanel;
        }
        var component = obj.getComponent(ComponentConstants.ComponentType.JoineryType);

        if (component !== null) {
            PlanManager.getInstance().executeCommand(new Commands.EditComponentCommand(component, modele));
        }
        else {
            PlanManager.getInstance().executeCommand(new Commands.AddComponentCommand(new JoineryType(modele._id, modele.manufacturer, modele.retailer), obj, true, false));
        }

        this.itemPreview = this.getJoineryPreviewUrl(modele);

        // Lapeyre custom canopy
        if (modele._id === "5fad1c4a8f1b8b7ad9c2ce98") {
            var canopy = obj as Canopy;
            if (canopy.height < SceneConstants.MinimalLapeyreCanopyHeight) {
                canopy.height = SceneConstants.MinimalLapeyreCanopyHeight;
            }
            if (canopy.height > SceneConstants.MaxLapeyreCanopyHeight) {
                canopy.height = SceneConstants.MaxLapeyreCanopyHeight;
            }

            if (canopy.length < SceneConstants.MinimalLapeyreCanopyLength) {
                canopy.length = SceneConstants.MinimalLapeyreCanopyLength;
            }
            if (canopy.length > SceneConstants.MaxLapeyreCanopyLength) {
                canopy.length = SceneConstants.MaxLapeyreCanopyLength;
            }

            canopy.computeLapeyreCanopyCasement();
        }

        this.updateProperties(undefined as any);
    };

    openAssetDetail = (res: any) => {
        var path = 'joineries/';
        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + res._id);
            return;
        }
        window.open(getFrontUrl() + path + res._id);
    }

    openEntityDetail = () => {
        var path = 'joineries/';
        var comp = this.entity.getComponent(ComponentConstants.ComponentType.JoineryType) as JoineryType;
        if (!comp) return;
        var id = comp.joineryTypeId;

        if (this.openAssetDetailCallback) {
            this.openAssetDetailCallback(getFrontUrl() + path + id);
            return;
        }
        window.open(getFrontUrl() + path + id);
    }

    updatepreviewJoinery() {
        var component = this.entity.getComponent(ComponentConstants.ComponentType.JoineryType) as JoineryType;
        if (component !== null) {
            this.itemPreview = getMediaUrl() + 'joineries/' + component.joineryTypeId + '/medias/previews/preview1-sm.webp';
            if (ARRMGR_CLOUDINARY_ALLOWED) {
                this.itemPreview = ARRMGR_CLOUDINARY_URL + component.joineryTypeId + '/medias/previews/preview1-sm.webp';
            } 
            let image = document.getElementById('previewCurrentJoinery');
            if (image && image.getElementsByTagName("img")[0]) {
                image.getElementsByTagName("img")[0].src = this.itemPreview;
            }
        }
    }

    initMaterialType() {
        var component = this.entity.getComponent(ComponentConstants.ComponentType.JoineryType) as JoineryType;
        // Cuisinella simple material cupboard
        if (component && (component.joineryTypeId === "5ff486976324651be13128e7" ||
            component.joineryTypeId === "5ff48b45bf75301c610dff42")) {
            if (this.entity.materialType < 1000 || this.entity.materialType >= 2000) {
                this.model.materialType = '1008';
                this.entity.materialType = 1008;
            }
        }
        // Cuisinella double cupboard
        else if (component && (component.joineryTypeId === "5ff48f4ac904e750cb52cd99" ||
            component.joineryTypeId === "5ff4943c4b141c1c07598803")) {
            if (this.entity.materialType < 2000 || this.entity.materialType >= 3000) {
                this.model.materialType = '2001';
                this.entity.materialType = 2001;
            }
        }
        else if (this.entity.materialType >= 1000 || !this.entity.materialType) {
            this.model.materialType = '0';
            this.entity.materialType = 0;
        }
    };

    updateJoineryProperties() {
        switch (this.entity.joineryType) {
            case SceneConstants.JoineryType.door:
            case SceneConstants.JoineryType.frontDoor:
            case SceneConstants.JoineryType.window:
            case SceneConstants.JoineryType.frenchWindow:
            case SceneConstants.JoineryType.pictureWindow:
            case SceneConstants.JoineryType.fixedWindow:
            case SceneConstants.JoineryType.canopy:
            case SceneConstants.JoineryType.cupboardDoor:
            case SceneConstants.JoineryType.garageDoor:
            case SceneConstants.JoineryType.niche:
                this.updateCommonJoineryProperties();
                this.initMaterialType();
                break;
            case SceneConstants.JoineryType.velux:
            case SceneConstants.JoineryType.opening:
                this.updateCommonJoineryProperties();
                break;
        }
    }

    updateCommonJoineryProperties() {
        // Set door quantity
        if (this.entity.joineryType == SceneConstants.JoineryType.door
            || this.entity.joineryType == SceneConstants.JoineryType.frontDoor
            || this.entity.joineryType == SceneConstants.JoineryType.frenchWindow
            || this.entity.joineryType == SceneConstants.JoineryType.pictureWindow) {
            var nbDoors = document.getElementById('box-nbDoors') as HTMLInputElement;
            if (nbDoors) {
                nbDoors.value = (this.entity as any)[GUIConstants.NB_DOORS];
            }
        } else if (this.entity.joineryType === SceneConstants.JoineryType.window) {
            var nbCasement = document.getElementById('box-nbCasement') as HTMLInputElement;
            if (nbCasement) {
                nbCasement.value = (this.entity as any)[GUIConstants.NB_CASEMENTS];
            }
        }
    };

    getJoineryPreviewUrl(modele: any): string {
        if (modele !== null) {
            var url = getMediaUrl() +
                'joineries/' +
                modele._id +
                '/medias/previews/preview1-sm.webp';

            if (ARRMGR_CLOUDINARY_ALLOWED) {
                url = ARRMGR_CLOUDINARY_URL + modele._id + '/medias/previews/preview1-sm.webp';
            }
            return (url);
        }
        else {
            return (COCOS_PLAN_MODULE_PATH + "cocos/resources/loading.gif");
        }
    };


    getDataName(name: any): string {
        var component = this.entity.getComponent(ComponentConstants.ComponentType.JoineryType) as JoineryType;

        if (component) {
            // Cuisinella simple material cupboard
            if (component.joineryTypeId === "5ff486976324651be13128e7" ||
                component.joineryTypeId === "5ff48b45bf75301c610dff42") {
                return "joineryCuisinellaSimpleCupboardMaterialTypeList";
            }
            // Cuisinella double material cupboard
            else if (component.joineryTypeId === "5ff48f4ac904e750cb52cd99" ||
                component.joineryTypeId === "5ff4943c4b141c1c07598803") {
                return "joineryCuisinellaDoubleCupboardMaterialTypeList";
            }
        }
        return name;
    }

    generateDropdownData() {
        if (!this.entity) return;
        this.dropDownData = [
            {id: SceneConstants.JoineryType.door, name: "Porte", model: SceneConstants.DefaultJoineryType.door},
            {id: SceneConstants.JoineryType.frontDoor, name: "Porte d'entrée", model: SceneConstants.DefaultJoineryType.frontDoor},
            {id: SceneConstants.JoineryType.window, name: "Fenêtre", model: SceneConstants.DefaultJoineryType.window},
            {id: SceneConstants.JoineryType.frenchWindow, name: "Porte fenêtre", model: SceneConstants.DefaultJoineryType.frenchWindow},
            {id: SceneConstants.JoineryType.pictureWindow, name: "Baie vitrée", model: SceneConstants.DefaultJoineryType.pictureWindow},
            {id: SceneConstants.JoineryType.canopy, name: "Verrière", model: SceneConstants.DefaultJoineryType.canopy},
            {id: SceneConstants.JoineryType.opening, name: "Ouverture", model: SceneConstants.DefaultJoineryType.opening},
            {id: SceneConstants.JoineryType.cupboardDoor, name: "Placard", model: SceneConstants.DefaultJoineryType.cupboardDoor},
            {id: SceneConstants.JoineryType.garageDoor, name: "Porte de garage", model: SceneConstants.DefaultJoineryType.garageDoor},
            {id: SceneConstants.JoineryType.niche, name: "Niche", model: SceneConstants.DefaultJoineryType.niche},
            {id: SceneConstants.JoineryType.fixedWindow, name: "Châssis fixe", model: SceneConstants.DefaultJoineryType.fixedWindow}
        ].sort(function (a, b): number {
            return a.name.localeCompare(b.name);
        });
    };
}
